<template>
    <div class="page-order page-content" v-loading="body_loading">
        <div class="main-body">
            <el-row class="hd">
                <el-col :span="24">
                    <h3 style="float: none;">交易记录</h3>
                    <div class="flex-block breadcrumb-box">
                        <div class="position-text">位置：</div>
                        <el-breadcrumb separator-class="el-icon-arrow-right">
                            <el-breadcrumb-item>订单管理</el-breadcrumb-item>
                            <el-breadcrumb-item>交易记录</el-breadcrumb-item>
                        </el-breadcrumb>
                    </div>
                </el-col>
            </el-row>
            <div class="bd">
                <div class="search-block content-body">
                    <el-form :inline="true" ref="formSearch" :model="form_search" class="demo-form-inline" @submit.native.prevent>
                        <el-form-item prop="order_number" label="订单号：" style="margin-bottom: 0;">
                            <el-input v-model="form_search.order_number" size="small" placeholder="请输入订单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="user_number" label="用户编号：">
                            <el-input v-model="form_search.user_number" type='number' size="small" placeholder="请输入用户编号" clearable></el-input>
                        </el-form-item>
						<el-form-item prop="card_number" label="实体卡号：" style="margin-bottom: 0;">
						    <el-input v-model="form_search.card_number" size="small" placeholder="请输入订单号" clearable></el-input>
						</el-form-item>
      <!--                  <el-form-item prop="user_id" label="用户ID：">
                            <el-input v-model="form_search.user_id" type='number' size="small" placeholder="请输入用户ID" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item prop="transaction_id" label="微信支付单号：">
                            <el-input v-model="form_search.transaction_id" size="small" placeholder="请输入微信支付单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="balance_pay_number" label="余额支付单号：">
                            <el-input v-model="form_search.balance_pay_number" size="small" placeholder="请输入余额支付单号" clearable></el-input>
                        </el-form-item>
                        <el-form-item prop="amount" label="支付金额：">
                            <el-input v-model="form_search.amount" type='number' size="small" placeholder="请输入支付金额" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="下单时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="create_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="支付时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="pay_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="取消时间：">
                            <el-date-picker
                                    size="small"
                                    clearable
                                    v-model="cancel_range"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item style="margin-bottom: 0;">
                            <el-button type="primary" class="search-btn"  size="medium" @click='searchList()'>查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-block content-body">
                    <div ref="contentBody">
                        <el-table ref="multipleTable" :data="table_data.list" v-loading="table_data.loading" tooltip-effect="dark" style="width: 100%;text-align: center;">
                            <el-table-column prop="order_number" align="center" label="订单编号" min-width="160">
                                <template slot-scope="scope">
                                    <my-textEllipsis v-if="is_refresh" :content="scope.row.order_number"></my-textEllipsis>
                                </template>
                            </el-table-column>
<!--                            <el-table-column prop="user_id" align="center" label="用户ID" min-width="90">
                            </el-table-column> -->
                            <el-table-column prop="user_number" align="center" label="用户编号" min-width="160">
                                <template slot-scope="scope">
                                    <span class="user-num-span" @click="$util.goTo('/user/list',{query:{user_number:scope.row.user_number}})">{{scope.row.user_number}}</span>
                                </template>
                            </el-table-column>
							<el-table-column prop="card_number" align="center" label="实体卡号" min-width="120">
							</el-table-column>
                            <el-table-column prop="nick_name" align="center" label="用户昵称" min-width="120">
                            </el-table-column>
                            <el-table-column prop="avatar_url" align="center" label="用户头像" min-width="80">
                                <template slot-scope="scope">
                                    <img class="cursor" :src="scope.row.avatar_url" height="23" @click="dlg_preview.img_url = scope.row.avatar_url;dlg_preview.visible = true;" title="点击查看" />
                                </template>
                            </el-table-column>
                            <el-table-column prop="pay_type" align="center" label="余额支付单号/微信支付单号" min-width="160">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.pay_type==1">{{scope.row.transaction_id}}</span>
                                    <span v-else-if="scope.row.pay_type==2">{{scope.row.balance_pay_number}}</span>
                                </template>
                            </el-table-column>
                            <!--<el-table-column prop="c_time" sortable="custom" align="center" label="下单时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="pay_date" sortable="custom" align="center" label="支付时间" min-width="160">
                            </el-table-column>
                            <el-table-column prop="cancel_time" sortable="custom" align="center" label="取消时间" min-width="160">
                                <template slot-scope="scope">
                                   <span>{{scope.row.cancel_time==0?'':scope.row.cancel_time}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="amount" sortable="custom" align="center" label="支付金额" min-width="180">-->
                            <el-table-column prop="c_time" align="center" label="下单时间" min-width="130">
                            </el-table-column>
                            <el-table-column prop="pay_date" align="center"label="支付时间" min-width="130">
                            </el-table-column>
                            <!--<el-table-column prop="cancel_time" align="center" label="取消时间" min-width="160">
                                <template slot-scope="scope">
                                    <span>{{scope.row.cancel_time==0?'':scope.row.cancel_time}}</span>
                                </template>
                            </el-table-column>-->
                            <el-table-column prop="amount" align="center" label="支付金额" min-width="80">
                            </el-table-column>
                            <el-table-column prop="pay_type_name" align="center" label="支付方式" min-width="100">
                                <template slot-scope="scope">
                                    <span :class="'tag-span tag-'+(scope.row.pay_type+1)">{{scope.row.pay_type_name}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="status_name" align="center" label="状态" min-width="80" fixed="right">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.type==1" :class="'status1-'+scope.row.status">{{scope.row.status_name}}</span>
                                    <span v-else-if="scope.row.type==2" :class="'status2-'+scope.row.status">{{scope.row.status_name}}</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="table_data.page_info.page"
                            :page-sizes="[10,30, 50,80,100]"
                            :page-size="table_data.page_info.pageSize"
                            layout="total, sizes, prev, pager, next"
                            :total="table_data.page_info.total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible.sync="dlg_preview.visible" class="dialog-no-title text-center" width="420px">
            <img width="100%" :src="dlg_preview.img_url" style="max-width:100%;">
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'usercenter',
        data() {
            return {
                clientHeight:'',
                body_loading:false,
                is_refresh: true,
                create_range:'',
                pay_range:'',
                cancel_range:'',
                form_search:{
                    order_number:'',
                    user_number:"",
					card_number:"",
                    //mobile:'',
                    user_id:'',
                    transaction_id:'',
                    balance_pay_number:'',
                    amount: '',
                    start_create_date:'',
                    end_create_date:'',
                    start_pay_date:'',
                    end_pay_date:'',
                    start_cancel_date:'',
                    end_cancel_date:'',
                    //sort_type:''
                },
                init_data: {
                    type_list:[],
                    status_list: [],
                },
                table_data:{
                    loading: false,
                    list:[],
                    page_info: {
                        page: 1,
                        pageSize: 10,
                        total: 130
                    }
                },
                dlg_preview:{
                    visible: false,
                    img_url: ''
                }
            }
        },
        created() {
            document.title = '支付记录';
            this.getList();
        },
        methods: {
            searchList(){
                var _this = this;
                _this.table_data.page_info.page = 1;
                _this.getList();
            },
            getList() {
                var _this = this;
                var params = _this.form_search;
                params.p = _this.table_data.page_info.page;
                params.pageSize = _this.table_data.page_info.pageSize;
                _this.table_data.loading = true;
                var status_list = [{id:-1, name: '全部'}];
                this.$client.get('/adminapi/orderpay/list', params, function(res,message){
                    _this.table_data.list = res.list;
                    _this.table_data.page_info = res.pager;
                    _this.init_data.type_list = status_list.concat(res.pay_type_name_list);
                    _this.init_data.status_list = status_list.concat(res.status_name_list);
                    _this.table_data.loading = false;
                },function(res){
                    _this.table_data.loading = false;
                });
            },
            /*orderSortChange(column){
                this.table_data.page_info.page = 1;
                if(column.order == "ascending"){
                    if(column.prop == "c_time"){
                        this.form_search.sort_type = 'c_time:asc';
                    }else if(column.prop == "pay_date"){
                        this.form_search.sort_type = 'pay_date:asc';
                    }else if(column.prop == "paid_amount"){
                        this.form_search.sort_type = 'paid_amount:asc';
                    }
                }else if(column.order == "descending") {
                    if(column.prop == "c_time"){
                        this.form_search.sort_type = 'c_time:desc';
                    }else if(column.prop == "pay_date"){
                        this.form_search.sort_type = 'pay_date:desc';
                    }else if(column.prop == "paid_amount"){
                        this.form_search.sort_type = 'paid_amount:desc';
                    }
                }else{
                    return;
                }
                this.getList();
            },*/
            handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
                this.table_data.page_info.pageSize = val;
                this.getList();
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                this.table_data.page_info.page = val;
                this.getList();
            },
            changeFixed(clientHeight){
                this.$refs.contentBody.style.minHeight = (clientHeight-394)+'px';
            }
        },
        mounted(){
            // 获取浏览器可视区域高度
            this.clientHeight =   `${document.documentElement.clientHeight}`          //document.body.clientWidth;
            //console.log(self.clientHeight);
            window.onresize = function temp() {
                this.clientHeight = `${document.documentElement.clientHeight}`;
            };
        },
        watch: {
            // 如果 `clientHeight` 发生改变，这个函数就会运行
            clientHeight: function () {
                this.changeFixed(this.clientHeight)
            },
            create_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_create_date = '';
                    this.form_search.end_create_date = '';
                }else{
                    this.form_search.start_create_date = newVal[0];
                    this.form_search.end_create_date = newVal[1];
                }
            },
            pay_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_pay_date = '';
                    this.form_search.end_pay_date = '';
                }else{
                    this.form_search.start_pay_date = newVal[0];
                    this.form_search.end_pay_date = newVal[1];
                }
            },
            cancel_range(newVal){
                //console.log(newVal);
                if(newVal == null){
                    this.form_search.start_cancel_date = '';
                    this.form_search.end_cancel_date = '';
                }else{
                    this.form_search.start_cancel_date = newVal[0];
                    this.form_search.end_cancel_date = newVal[1];
                }
            }
        }
    }
</script>
<style>

</style>
<style scoped>
    .status1-0{
        color: #F27918;
    }
    .status1-9{
        color: #04B365;
    }
    .status1-10{
        color: #F31A5C;
    }
    .status1-11{
        color: #666;
    }

    .status2-0{
        color: #F27918;
    }
    .status2-9{
        color: #0C67F0;
    }
    .status2-10{
        color: #f00;
    }
    .status2-11{
        color: #666;
    }
</style>